import { filterValidDocumentFiles } from '@/utils/document-upload'
import { validateMassiveImportFileName } from '@/utils/massive-import-file-validation'

const newId = () => {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID()
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`
}

export const prepareMassiveAttachmentFiles = ({ files, validationType, validateFileSize }) => {
  const { validFiles: typeValidFiles, errors } = filterValidDocumentFiles(files)
  const validFiles = []

  typeValidFiles.forEach((file) => {
    const sizeError = validateFileSize(file)
    const nameError = validateMassiveImportFileName(file, validationType)
    const error = sizeError || nameError

    if (error) {
      errors.push(error)
      return
    }

    validFiles.push({
      id: newId(),
      file,
      filename: file.name,
      content_type: file.type,
      size: file.size
    })
  })

  return { validFiles, errors }
}

export const buildMassiveAttachmentQueue = ({ rows, resourceType, context = {} }) => (
  rows.flatMap((row) => row.files.map((selectedFile) => ({
    id: selectedFile.id,
    file: selectedFile.file,
    filename: selectedFile.filename,
    size: selectedFile.size,
    resourceType,
    attachmentTypeId: row.attachment_type.value,
    periodMonth: row.period_month,
    periodYear: row.period_year,
    contractorContractId: row.contractor_contract?.value,
    assetCategoryId: context.assetCategoryId,
    assetTypeId: context.assetTypeId,
    status: 'pending',
    progress: 0,
    error: null
  })))
)

export const duplicateMassiveAttachmentTargets = (items) => {
  const seen = new Set()
  const duplicates = []

  items.forEach((item) => {
    const target = [
      item.resourceType,
      item.filename.toLowerCase(),
      item.attachmentTypeId,
      item.periodMonth || '',
      item.periodYear || '',
      item.contractorContractId || '',
      item.assetCategoryId || '',
      item.assetTypeId || ''
    ].join(':')

    if (seen.has(target)) duplicates.push(item.filename)
    seen.add(target)
  })

  return [...new Set(duplicates)]
}
